import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { format, parseISO } from 'date-fns';
import { rem, SettingsItem, SettingsSection, SettingsItemTitle, SettingsItemContent, SettingsItemDescription, } from 'design-system';
import { IconEmail, IconPhone } from 'design-system/icons';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import IconShieldFail from 'design-system/icons/IconShieldFail';
import TouchableBounce from 'utils/packages/TouchableBounce';
const BreachCardTitle = ({ breach, isUnlocked, }) => {
    const styles = useStyles(styleSet);
    return (<SettingsItem iconSize={44} icon={<IconShieldFail colorKey="statusNegative"/>}>
      <SettingsItemContent style={styles.contentContainer}>
        {isUnlocked ? (<SettingsItemTitle>{breach.title}</SettingsItemTitle>) : (<View style={styles.blockContainer}/>)}
        <SettingsItemDescription>
          {format(parseISO(breach.breachDateAt), 'd MMM yyyy')}
        </SettingsItemDescription>
      </SettingsItemContent>
    </SettingsItem>);
};
const BreachCard = ({ breach, onPress, isUnlocked, }) => {
    const styles = useStyles(styleSet);
    const handlePress = useCallback(() => {
        onPress(breach);
    }, [breach, onPress]);
    return (<TouchableBounce onPress={handlePress}>
      <SettingsSection noMarginTop pointerEvents="none" style={styles.card}>
        <BreachCardTitle breach={breach} isUnlocked={isUnlocked}/>
        {breach.compromisedAccounts?.map((acc) => acc.accountType === 'phone' ? (<SettingsItem key={acc.id} title={acc.account} icon={<IconPhone gradientKey="darkPurple"/>} iconSize={44}/>) : (<SettingsItem key={acc.id} title={acc.account} icon={<IconEmail gradientKey="darkPink"/>} iconSize={44}/>))}
      </SettingsSection>
    </TouchableBounce>);
};
const styleSet = createStyleSheets((colors) => ({
    contentContainer: {
        flex: 1,
        justifyContent: 'center',
    },
    blockContainer: {
        width: rem(110),
        height: rem(24),
        borderRadius: rem(9),
        backgroundColor: colors.buttons.secondary,
    },
    card: {
        marginBottom: rem(16),
    },
}));
export default memo(BreachCard);
